export const MAX_PAGE_WIDTH = '1280px'
export const MAX_PAGE_WIDTH_FULL = '1680px'
